<!--
  ~ Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->

<form class="users__filter" [formGroup]="filterFormGroup">
  <div class="users-domain__filter">
    <mat-checkbox formControlName="domainOpengamma" (change)="updateFilter()">
      OpenGamma
    </mat-checkbox>
    <mat-checkbox formControlName="domainOthers" (change)="updateFilter()">Others</mat-checkbox>
  </div>
  <div>
    <mat-form-field class="form__input">
      <input
        matInput
        formControlName="nameQuery"
        placeholder="Filter by name"
        (keyup)="updateFilter()"
      />
    </mat-form-field>
  </div>
</form>
